<script setup>
defineProps({
  blok: { type: Object, required: true },
  stockist: { type: Boolean, default: false },
});
</script>

<template>
  <Container
    :style="{ backgroundColor: blok?.backgroundColour ?? 'inherit' }"
    :default-padding="false"
    container-class="px-5 md:pr-0 lg:pl-10 2xl:pl-20"
  >
    <div
      v-editable="blok"
      :class="{
        'md:py-20 py-5': !blok.image?.filename && !stockist,
        'md:w-[700px]': !blok.image?.filename,
        'flex flex-col md:flex-row gap-5 xl:gap-20 items-center justify-between md:py-0':
          blok.image?.filename,
      }"
    >
      <div
        class="flex flex-col gap-5 justify-center md:py-5 pb-5 pt-[30px]"
        :class="{
          'lg:w-[412px] md:w-[330px]': !!blok?.image?.filename,
        }"
      >
        <Heading
          :heading="blok.heading"
          :subtitle="blok.subtitle"
          heading-level="h1"
        />

        <p
          v-if="blok.description"
          class="text-[19px] lg:text-[21px] font-calson"
        >
          {{ blok.description }}
        </p>

        <div v-if="blok.button?.length">
          <Button
            v-for="button in blok.button"
            :key="button._uid"
            :blok="button"
          />
        </div>
      </div>
      <Image
        v-if="blok.image.filename"
        class="md:m-0 -mx-5 xl:h-[568px] lg:h-[370px] md:h-[277px] md:w-auto w-screen"
        :blok="{
          image: blok.image,
          ratio: '4x3',
        }"
      />
    </div>
  </Container>
</template>
